// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__EsIoV","text":"Switch_text__kksCO","track":"Switch_track__N6Kh6","knob":"Switch_knob__8Q1Jg"};